/**
 * Publishes the scroll offset once per frame as `--sy`; CSS applies per-layer rates.
 */
export default function parallax() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
    if (!matchMedia('(hover: hover)').matches) { return; }

    var root = document.documentElement;
    var ticking = false;

    function publish() {
        root.style.setProperty('--sy', window.scrollY + 'px');
        ticking = false;
    }

    addEventListener(
        'scroll',
        function () {
            if (ticking) { return; }
            ticking = true;
            requestAnimationFrame(publish);
        },
        { passive: true }
    );

    publish();
}
